import { call, put } from "redux-saga/effects";
import { ACTIONS, API_URL } from "../_config";
import { CallApi } from "./api/callApi";

export function* getJobseekersWithVideo(action: any): any {
  try {
    const { params = {} } = action.payload || {};

    const url = API_URL.VIDEO_CV.GET_JOBSEEKERS_WITH_VIDEO;
    const resp = yield call(CallApi.GET, url, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}
